import ForgotPassword from "./pages/forgot-password";
import LoginPage from "./pages/login/login-page";
import ResetPassword from "./pages/reset-password";

const sessionRoutes = [
  {
    path: "/session/login",
    element: <LoginPage />,
  },
  {
    path: "/session/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/session/reset-password",
    element: <ResetPassword />,
  },
];

export default sessionRoutes;
